import { Component, isValidElement, type PropsWithChildren, type ReactNode } from 'react'
import { Logger } from '@core/logger'
import { reportPageError } from './pageErrorReport'

type TScreenErrorBoundaryState = { hasError: boolean }

const screenKeyOf = (children: ReactNode) => (isValidElement(children) ? children.key : null)

export class ScreenErrorBoundary extends Component<PropsWithChildren, TScreenErrorBoundaryState> {
    constructor(props: PropsWithChildren) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError(): TScreenErrorBoundaryState {
        return { hasError: true }
    }

    componentDidUpdate(previous: PropsWithChildren) {
        const { children } = this.props
        const { hasError } = this.state

        if (screenKeyOf(previous.children) === screenKeyOf(children)) {
            return
        }

        if (hasError) {
            this.setState({ hasError: false })
        }
    }

    componentDidCatch(error: unknown) {
        Logger.error(error instanceof Error ? error : String(error))
        reportPageError(error)
    }

    render() {
        const { children } = this.props
        const { hasError } = this.state

        return hasError ? null : children
    }
}
